import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { __awaiter } from "tslib";
import { Ticker } from "../clock/Ticker";
import { isAudioContext } from "../util/AdvancedTypeCheck";
import { optionsFromArguments } from "../util/Defaults";
import { Timeline } from "../util/Timeline";
import { isDefined, isString } from "../util/TypeCheck";
import { createAudioContext, createAudioWorkletNode as _createAudioWorkletNode } from "./AudioContext";
import { closeContext, initializeContext } from "./ContextInitialization";
import { BaseContext } from "./BaseContext";
import { assert } from "../util/Debug";
/**
 * Wrapper around the native AudioContext.
 * @category Core
 */
export var Context = /*#__PURE__*/function (_BaseContext) {
  _inherits(Context, _BaseContext);
  function Context() {
    var _this;
    _classCallCheck(this, Context);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Context).call(this));
    _this.name = "Context";
    /**
     * An object containing all of the constants AudioBufferSourceNodes
     */
    _this._constants = new Map();
    /**
     * All of the setTimeout events.
     */
    _this._timeouts = new Timeline();
    /**
     * The timeout id counter
     */
    _this._timeoutIds = 0;
    /**
     * Private indicator if the context has been initialized
     */
    _this._initialized = false;
    /**
     * Indicates if the context is an OfflineAudioContext or an AudioContext
     */
    _this.isOffline = false;
    //--------------------------------------------
    // AUDIO WORKLET
    //--------------------------------------------
    /**
     * Maps a module name to promise of the addModule method
     */
    _this._workletModules = new Map();
    var options = optionsFromArguments(Context.getDefaults(), arguments, ["context"]);
    if (options.context) {
      _this._context = options.context;
    } else {
      _this._context = createAudioContext({
        latencyHint: options.latencyHint
      });
    }
    _this._ticker = new Ticker(_this.emit.bind(_assertThisInitialized(_assertThisInitialized(_this)), "tick"), options.clockSource, options.updateInterval);
    _this.on("tick", _this._timeoutLoop.bind(_assertThisInitialized(_assertThisInitialized(_this))));
    // fwd events from the context
    _this._context.onstatechange = function () {
      _this.emit("statechange", _this.state);
    };
    _this._setLatencyHint(options.latencyHint);
    _this.lookAhead = options.lookAhead;
    return _this;
  }
  _createClass(Context, [{
    key: "initialize",
    /**
     * Finish setting up the context. **You usually do not need to do this manually.**
     */
    value: function initialize() {
      if (!this._initialized) {
        // add any additional modules
        initializeContext(this);
        this._initialized = true;
      }
      return this;
    } //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
  }, {
    key: "createAnalyser",
    value: function createAnalyser() {
      return this._context.createAnalyser();
    }
  }, {
    key: "createOscillator",
    value: function createOscillator() {
      return this._context.createOscillator();
    }
  }, {
    key: "createBufferSource",
    value: function createBufferSource() {
      return this._context.createBufferSource();
    }
  }, {
    key: "createBiquadFilter",
    value: function createBiquadFilter() {
      return this._context.createBiquadFilter();
    }
  }, {
    key: "createBuffer",
    value: function createBuffer(numberOfChannels, length, sampleRate) {
      return this._context.createBuffer(numberOfChannels, length, sampleRate);
    }
  }, {
    key: "createChannelMerger",
    value: function createChannelMerger(numberOfInputs) {
      return this._context.createChannelMerger(numberOfInputs);
    }
  }, {
    key: "createChannelSplitter",
    value: function createChannelSplitter(numberOfOutputs) {
      return this._context.createChannelSplitter(numberOfOutputs);
    }
  }, {
    key: "createConstantSource",
    value: function createConstantSource() {
      return this._context.createConstantSource();
    }
  }, {
    key: "createConvolver",
    value: function createConvolver() {
      return this._context.createConvolver();
    }
  }, {
    key: "createDelay",
    value: function createDelay(maxDelayTime) {
      return this._context.createDelay(maxDelayTime);
    }
  }, {
    key: "createDynamicsCompressor",
    value: function createDynamicsCompressor() {
      return this._context.createDynamicsCompressor();
    }
  }, {
    key: "createGain",
    value: function createGain() {
      return this._context.createGain();
    }
  }, {
    key: "createIIRFilter",
    value: function createIIRFilter(feedForward, feedback) {
      // @ts-ignore
      return this._context.createIIRFilter(feedForward, feedback);
    }
  }, {
    key: "createPanner",
    value: function createPanner() {
      return this._context.createPanner();
    }
  }, {
    key: "createPeriodicWave",
    value: function createPeriodicWave(real, imag, constraints) {
      return this._context.createPeriodicWave(real, imag, constraints);
    }
  }, {
    key: "createStereoPanner",
    value: function createStereoPanner() {
      return this._context.createStereoPanner();
    }
  }, {
    key: "createWaveShaper",
    value: function createWaveShaper() {
      return this._context.createWaveShaper();
    }
  }, {
    key: "createMediaStreamSource",
    value: function createMediaStreamSource(stream) {
      assert(isAudioContext(this._context), "Not available if OfflineAudioContext");
      var context = this._context;
      return context.createMediaStreamSource(stream);
    }
  }, {
    key: "createMediaElementSource",
    value: function createMediaElementSource(element) {
      assert(isAudioContext(this._context), "Not available if OfflineAudioContext");
      var context = this._context;
      return context.createMediaElementSource(element);
    }
  }, {
    key: "createMediaStreamDestination",
    value: function createMediaStreamDestination() {
      assert(isAudioContext(this._context), "Not available if OfflineAudioContext");
      var context = this._context;
      return context.createMediaStreamDestination();
    }
  }, {
    key: "decodeAudioData",
    value: function decodeAudioData(audioData) {
      return this._context.decodeAudioData(audioData);
    }
    /**
     * The current time in seconds of the AudioContext.
     */
  }, {
    key: "createAudioWorkletNode",
    /**
     * Create an audio worklet node from a name and options. The module
     * must first be loaded using [[addAudioWorkletModule]].
     */
    value: function createAudioWorkletNode(name, options) {
      return _createAudioWorkletNode(this.rawContext, name, options);
    }
    /**
     * Add an AudioWorkletProcessor module
     * @param url The url of the module
     * @param name The name of the module
     */
  }, {
    key: "addAudioWorkletModule",
    value: function addAudioWorkletModule(url, name) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              assert(isDefined(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)");
              if (!this._workletModules.has(name)) {
                this._workletModules.set(name, this.rawContext.audioWorklet.addModule(url));
              }
              _context.next = 4;
              return this._workletModules.get(name);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Returns a promise which resolves when all of the worklets have been loaded on this context
     */
  }, {
    key: "workletsAreReady",
    value: function workletsAreReady() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var promises;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              promises = [];
              this._workletModules.forEach(function (promise) {
                return promises.push(promise);
              });
              _context2.next = 4;
              return Promise.all(promises);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    } //---------------------------
    // TICKER
    //---------------------------
    /**
     * How often the interval callback is invoked.
     * This number corresponds to how responsive the scheduling
     * can be. context.updateInterval + context.lookAhead gives you the
     * total latency between scheduling an event and hearing it.
     */
  }, {
    key: "_setLatencyHint",
    /**
     * Update the lookAhead and updateInterval based on the latencyHint
     */
    value: function _setLatencyHint(hint) {
      var lookAheadValue = 0;
      this._latencyHint = hint;
      if (isString(hint)) {
        switch (hint) {
          case "interactive":
            lookAheadValue = 0.1;
            break;
          case "playback":
            lookAheadValue = 0.5;
            break;
          case "balanced":
            lookAheadValue = 0.25;
            break;
        }
      }
      this.lookAhead = lookAheadValue;
      this.updateInterval = lookAheadValue / 2;
    }
    /**
     * The unwrapped AudioContext or OfflineAudioContext
     */
  }, {
    key: "now",
    /**
     * The current audio context time plus a short [[lookAhead]].
     */
    value: function now() {
      return this._context.currentTime + this.lookAhead;
    }
    /**
     * The current audio context time without the [[lookAhead]].
     * In most cases it is better to use [[now]] instead of [[immediate]] since
     * with [[now]] the [[lookAhead]] is applied equally to _all_ components including internal components,
     * to making sure that everything is scheduled in sync. Mixing [[now]] and [[immediate]]
     * can cause some timing issues. If no lookAhead is desired, you can set the [[lookAhead]] to `0`.
     */
  }, {
    key: "immediate",
    value: function immediate() {
      return this._context.currentTime;
    }
    /**
     * Starts the audio context from a suspended state. This is required
     * to initially start the AudioContext. See [[Tone.start]]
     */
  }, {
    key: "resume",
    value: function resume() {
      if (isAudioContext(this._context)) {
        return this._context.resume();
      } else {
        return Promise.resolve();
      }
    }
    /**
     * Close the context. Once closed, the context can no longer be used and
     * any AudioNodes created from the context will be silent.
     */
  }, {
    key: "close",
    value: function close() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isAudioContext(this._context)) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return this._context.close();
            case 3:
              if (this._initialized) {
                closeContext(this);
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * **Internal** Generate a looped buffer at some constant value.
     */
  }, {
    key: "getConstant",
    value: function getConstant(val) {
      if (this._constants.has(val)) {
        return this._constants.get(val);
      } else {
        var buffer = this._context.createBuffer(1, 128, this._context.sampleRate);
        var arr = buffer.getChannelData(0);
        for (var i = 0; i < arr.length; i++) {
          arr[i] = val;
        }
        var constant = this._context.createBufferSource();
        constant.channelCount = 1;
        constant.channelCountMode = "explicit";
        constant.buffer = buffer;
        constant.loop = true;
        constant.start(0);
        this._constants.set(val, constant);
        return constant;
      }
    }
    /**
     * Clean up. Also closes the audio context.
     */
  }, {
    key: "dispose",
    value: function dispose() {
      var _this2 = this;
      _get(_getPrototypeOf(Context.prototype), "dispose", this).call(this);
      this._ticker.dispose();
      this._timeouts.dispose();
      Object.keys(this._constants).map(function (val) {
        return _this2._constants[val].disconnect();
      });
      return this;
    } //---------------------------
    // TIMEOUTS
    //---------------------------
    /**
     * The private loop which keeps track of the context scheduled timeouts
     * Is invoked from the clock source
     */
  }, {
    key: "_timeoutLoop",
    value: function _timeoutLoop() {
      var now = this.now();
      var firstEvent = this._timeouts.peek();
      while (this._timeouts.length && firstEvent && firstEvent.time <= now) {
        // invoke the callback
        firstEvent.callback();
        // shift the first event off
        this._timeouts.shift();
        // get the next one
        firstEvent = this._timeouts.peek();
      }
    }
    /**
     * A setTimeout which is guaranteed by the clock source.
     * Also runs in the offline context.
     * @param  fn       The callback to invoke
     * @param  timeout  The timeout in seconds
     * @returns ID to use when invoking Context.clearTimeout
     */
  }, {
    key: "setTimeout",
    value: function setTimeout(fn, timeout) {
      this._timeoutIds++;
      var now = this.now();
      this._timeouts.add({
        callback: fn,
        id: this._timeoutIds,
        time: now + timeout
      });
      return this._timeoutIds;
    }
    /**
     * Clears a previously scheduled timeout with Tone.context.setTimeout
     * @param  id  The ID returned from setTimeout
     */
  }, {
    key: "clearTimeout",
    value: function clearTimeout(id) {
      var _this3 = this;
      this._timeouts.forEach(function (event) {
        if (event.id === id) {
          _this3._timeouts.remove(event);
        }
      });
      return this;
    }
    /**
     * Clear the function scheduled by [[setInterval]]
     */
  }, {
    key: "clearInterval",
    value: function clearInterval(id) {
      return this.clearTimeout(id);
    }
    /**
     * Adds a repeating event to the context's callback clock
     */
  }, {
    key: "setInterval",
    value: function setInterval(fn, interval) {
      var _this4 = this;
      var id = ++this._timeoutIds;
      var intervalFn = function intervalFn() {
        var now = _this4.now();
        _this4._timeouts.add({
          callback: function callback() {
            // invoke the callback
            fn();
            // invoke the event to repeat it
            intervalFn();
          },
          id: id,
          time: now + interval
        });
      };
      // kick it off
      intervalFn();
      return id;
    }
  }, {
    key: "currentTime",
    get: function get() {
      return this._context.currentTime;
    }
    /**
     * The current time in seconds of the AudioContext.
     */
  }, {
    key: "state",
    get: function get() {
      return this._context.state;
    }
    /**
     * The current time in seconds of the AudioContext.
     */
  }, {
    key: "sampleRate",
    get: function get() {
      return this._context.sampleRate;
    }
    /**
     * The listener
     */
  }, {
    key: "listener",
    get: function get() {
      this.initialize();
      return this._listener;
    },
    set: function set(l) {
      assert(!this._initialized, "The listener cannot be set after initialization.");
      this._listener = l;
    }
    /**
     * There is only one Transport per Context. It is created on initialization.
     */
  }, {
    key: "transport",
    get: function get() {
      this.initialize();
      return this._transport;
    },
    set: function set(t) {
      assert(!this._initialized, "The transport cannot be set after initialization.");
      this._transport = t;
    }
    /**
     * This is the Draw object for the context which is useful for synchronizing the draw frame with the Tone.js clock.
     */
  }, {
    key: "draw",
    get: function get() {
      this.initialize();
      return this._draw;
    },
    set: function set(d) {
      assert(!this._initialized, "Draw cannot be set after initialization.");
      this._draw = d;
    }
    /**
     * A reference to the Context's destination node.
     */
  }, {
    key: "destination",
    get: function get() {
      this.initialize();
      return this._destination;
    },
    set: function set(d) {
      assert(!this._initialized, "The destination cannot be set after initialization.");
      this._destination = d;
    }
  }, {
    key: "updateInterval",
    get: function get() {
      return this._ticker.updateInterval;
    },
    set: function set(interval) {
      this._ticker.updateInterval = interval;
    }
    /**
     * What the source of the clock is, either "worker" (default),
     * "timeout", or "offline" (none).
     */
  }, {
    key: "clockSource",
    get: function get() {
      return this._ticker.type;
    },
    set: function set(type) {
      this._ticker.type = type;
    }
    /**
     * The type of playback, which affects tradeoffs between audio
     * output latency and responsiveness.
     * In addition to setting the value in seconds, the latencyHint also
     * accepts the strings "interactive" (prioritizes low latency),
     * "playback" (prioritizes sustained playback), "balanced" (balances
     * latency and performance).
     * @example
     * // prioritize sustained playback
     * const context = new Tone.Context({ latencyHint: "playback" });
     * // set this context as the global Context
     * Tone.setContext(context);
     * // the global context is gettable with Tone.getContext()
     * console.log(Tone.getContext().latencyHint);
     */
  }, {
    key: "latencyHint",
    get: function get() {
      return this._latencyHint;
    }
  }, {
    key: "rawContext",
    get: function get() {
      return this._context;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return {
        clockSource: "worker",
        latencyHint: "interactive",
        lookAhead: 0.1,
        updateInterval: 0.05
      };
    }
  }]);
  return Context;
}(BaseContext);